import { Extensions } from '@tiptap/core'
import Image from '@tiptap/extension-image'
import { TableKit } from '@tiptap/extension-table'
import { Placeholder } from '@tiptap/extensions'
import StarterKit from '@tiptap/starter-kit'

/** Shared schema for the editor, the read-only viewer and HTML normalization */
export const createRichTextExtensions = (placeholder?: string): Extensions => [
  StarterKit.configure({
    heading: { levels: [1, 2, 3] },
    code: false,
    codeBlock: false,
    link: { openOnClick: false, autolink: true, defaultProtocol: 'https' },
  }),
  Image,
  TableKit.configure({ table: { resizable: false } }),
  ...(placeholder ? [Placeholder.configure({ placeholder })] : []),
]
